import React from 'react'
import styled from 'styled-components'

const LabelContainer = styled.div`
  position: relative;
  left: -19px;
  width: ${props => (props.showSliderLabel ? '30px' : 'auto')};
  text-align: center;
`

const StyledLabel = styled.span`
  position: absolute;
  top: ${props => (props.type === 'value' ? '-44px' : 'auto')};
  font-size: 14px;
  font-weight: 600;
  -webkit-text-stroke: 0.5px;
  left: ${props =>
    props.type === 'min' ? '-6px' : props.type === 'max' ? 'auto' : '-6px'};
  right: ${props => (props.type === 'max' ? '-34px' : 'auto')};
  bottom: ${props => (props.type !== 'value' ? '-26px' : 'auto')};
  text-rendering: optimizeLegibility;
  box-sizing: border-box;
  padding-left: 10px;
  user-select: none;
`

const Label = ({formatLabel, type, children, showSliderLabel}) => {
  const labelValue = formatLabel ? formatLabel(children, type) : children

  return (
    <StyledLabel type={type}>
      <LabelContainer
        showSliderLabel={showSliderLabel}
        data-testid="input-range-label"
      >
        {labelValue}
      </LabelContainer>
    </StyledLabel>
  )
}

Label.defaultProps = {
  showSliderLabel: true
}

export default Label
